import { Component, OnInit, ViewChild, NgZone } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
declare const Swal;

@Component({
  selector: 'app-edit-location',
  templateUrl: './edit-location.component.html',
  styleUrls: ['./edit-location.component.css']
})
export class EditLocationComponent implements OnInit {
  
  @ViewChild('modalHide') modalHide;
  
  public editLocationForm:FormGroup;
  public locationObj={};
  public selLocation={};
  public selectedValueClose = false;
  public locationSuggestions={};
  public firstLoadLocation:boolean=true;

  primaryMap: any;
  mapSearchDebounceTimeOut = null;
  mapSearchDataLists = [];
  markerId = 'pickLocation';

  public editLocation:boolean=true;
  public locationData = {};
  formSubmit:boolean=false;

  public locationID;
  public updateValues=[];
  public updateLocation:boolean=false;

  constructor(
    public api: ApiService,
    public swal: SweetAlert,
    public route: ActivatedRoute,
    public storage: StorageService,
    public router: Router,) { 
      this.route.paramMap.subscribe((params: any) => {
        this.locationID = params.params.locationID;  
      });

    }
    
  ngOnInit(): void {
    this.editLocationFormLoad();
    this.getLocationData();
  }
  editLocationFormLoad(){
    this.editLocationForm = new FormGroup({
      title: new FormControl('', [Validators.required]),
      location: new FormControl('', [Validators.required]),
    });
  }

  getLocationData(){
    const obj = {
        locationID: this.locationID
    };
    this.api.transportManagerLocationList(obj).then((res: any) => {
        if (res.status == 'success') {
            if (res.data.length>0){
              let data=res.data.find((e)=>e.locationID==this.locationID);
              this.locationObj=data;
              this.setValueEditLocationForm(data);
            }
        }  
    }).catch((err) => {
        console.log(err);
    });
  }

  setValueEditLocationForm(data){
    this.editLocationForm.patchValue({
      title: data.title,
      location: data.location.name,
    });
    this.locationData = { ...data.location};
  }

  getLocation(obj){
    this.selLocation = {...obj};
    this.fieldChange(this.selLocation,'location','location'); 
  }

  /* checking error in fields*/
  public checkError = (controlName: string, errorName: string) => {
    return this.editLocationForm.controls[controlName].hasError(errorName);
  }
  /* update unique field*/
  fieldChange(e:any,type,field){
    if(type=='text'){
      this.updateField(field,e.target.value);
    }
    if(type=='location'){
      this.updateField(field,e);
    }
  }
  updateField(field,value){
    if(this.updateValues.length>0){
      let filterUpdate=this.updateValues.filter((e)=>e.field!=field);
      let obj={field:field,value:value,};
      this.updateValues=[
        ...filterUpdate,
        obj,
      ]
    }
    else{
      let obj={field:field,value:value,};
      this.updateValues.push(obj);
    }
  }

  /* Cancel Edit*/
  cancel(){
    this.router.navigate(['/organization/transport-manager/information/orgInfo/location/view-location']);
  }
  /* Submit Data*/
  onSubmit(){
    this.formSubmit = true;
    if(this.updateValues && this.updateValues.length>0){
      const obj = {
        locationID:this.locationID,
      };
      this.updateValues.filter((e)=>{
        obj[e.field]=e.value;
      });
      this.api.transportManagerLocationUpdate(obj).then((res: any) => {
        if (res.status == 'success') {
          this.swal.swalFunction(res.status, res.status, res.message, 2000);
          this.router.navigate(['/organization/transport-manager/information/orgInfo/location/view-location'])
        }
        if (res.status == 'failure') {
          this.swal.swalFunction('error', res.status, res.message, 3000);
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  }

}
